import React, { useContext, useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap';
import firebase from '../../firestore';
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { Redirect } from "react-router-dom";
import { AuthContext } from '../AuthContext'
// import Loading from '../Loading'
import { Planets } from 'react-preloaders'
import loaderImg from '../../assets/loader.gif'
import Loading from '../../components/Loading'

const LoginComponent = (props) => {
    const [found, setFound] = useState(false)
    const [loading, setLoading] = useState(true)
    const [currentUser, setCurrentUser] = useContext(AuthContext)

    useEffect(() => {

        if (!currentUser.pending) {
            if (currentUser.user) {
                firebase.database().ref('/users/').orderByChild('email').equalTo(firebase.auth().currentUser.email).on("value", function (snapshot) {
                    if (snapshot.val() !== null) {
                        setFound(true)
                    }
                    setLoading(false)
                });
            }
            else {
                setLoading(false)
            }
        }
    }, [currentUser])

    const uiConfig = {
        signInFlow: "popup",
        signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID,],
        callbacks: {
            signInSuccess: () => { setLoading(true) }
        }
    }

    if (currentUser.pending || loading) {
        //TODO :change to loading animation
        // return <Planets customLoading={loading} time={0} color={'#DEEAF8'} background="#253044" />
        return (
            // <div>
            //     <img src={loaderImg} />

            // </div>
            // <h1 className="loadingHeading">Loading</h1>
            <Loading />
        )
    }

    if (currentUser.user) {
        if (found) {

            return (
                <Redirect to="/dashboard" />
            )
        }
        return (
            <Redirect to="/detailForm" />

        )
    }

    return (
        <div className="LoginPage">
            <Row>
                <Col className="LoginLeftPanel">
                    <div className="InsideLeft">

                    </div>
                </Col>
                <Col className="LoginRightPanel">
                    <div className="InsideRight">
                        <h3>Let's Get Going</h3>
                        <h5>To start on the CV all we need is a google account</h5>
                        <StyledFirebaseAuth
                            uiConfig={uiConfig}
                            firebaseAuth={firebase.auth()}
                        />

                    </div>
                </Col>
            </Row>

        </div>
    );
}



export default LoginComponent;